import styled, { css } from 'styled-components';
import { media } from '@prisjakt/ui-base';
import PriceLabelComponent from '@prisjakt/ui-price-label';
import { Align } from '../../types';

type PriceColumnProps = {
  align?: Align;
};

export const PriceColumn = styled.div<PriceColumnProps>`
  display: flex;
  flex-direction: column;
  justify-items: flex-start;
  align-items: flex-start;
  white-space: nowrap;

  ${p =>
    p.align === 'right' &&
    css`
      align-items: flex-end;
      text-align: right;
    `}
`;

export const ShippingLabelWrapper = styled.div`
  ${media.smallOnly`
      display:none;
    `}
`;

export const Hidden = styled.span`
  display: none;
`;

const priceSize = '18px';

export const PriceLabel = styled(PriceLabelComponent)`
  font-size: ${priceSize};
  text-align: right;
`;

export const ShippingLabelPlaceholder = styled.div`
  height: 18px;
  width: 1px;
`;
